import { ethToWei } from './ethToWei'
import { getChainCurrency } from './getChainCurrency'
import { getChainId } from './getChainId'
import { splitExists } from './splitExists'
import { weiToEth } from './weiToEth'

export const Web3 = {
  getChainId,
  ethToWei,
  weiToEth,
  splitExists,
  getChainCurrency
}
